module.exports = __webpack_public_path__ + "af.svg?071b4bb7a3dd6b5b950dad50af641d6b";